import { Stack } from '@mui/material';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { TConnectionConfigurationInputSchema } from '@/console/features/devices/components/create-device/create-device.types';
import { TCreateSMBConfigurationFormProps } from '@/console/features/devices/components/create-smb-configuration/create-smb-configuration-form.types';
import { FormSelectSecret } from '@/console/features/vaults/components/form-select-secret/form-select-secret';
import { FormInput } from '@/shared/components/ui/form/components/form-input/form-input';
import { IpAddressFormInput } from '@/shared/components/ui/form/components/form-input/variant/ip-address-form-input/ip-address-form-input';
import { FormSelect } from '@/shared/components/ui/form/components/form-select/form-select';
import { FormContent } from '@/shared/components/ui/form/form.styled';
import { OverlayLoader } from '@/shared/components/ui/overlay-loader/overlay-loader';
import { SmbProtocolEnum } from '@/shared/types/types.generated';

export const CreateSmbConfigurationForm: React.FC<
  TCreateSMBConfigurationFormProps
> = ({ isLoading, disabled }) => {
  const { t } = useTranslation();
  const { setValue } = useFormContext<TConnectionConfigurationInputSchema>();

  const getSmbProtocolOptions = () => {
    return [
      {
        label: 'SMB',
        value: SmbProtocolEnum.Smb,
      },
    ];
  };

  const handleSmbProtocolChange = () => {
    // Set default SMB ports based on protocol
    setValue('smbConfiguration.port', 445);
  };

  if (isLoading) {
    return <OverlayLoader display />;
  }

  return (
    <FormContent>
      <IpAddressFormInput<TConnectionConfigurationInputSchema>
        name="smbConfiguration.ipAddress"
        label={t('device:ip_address_plc')}
        disabled={disabled}
      />
      <Stack direction="row" gap="0.5rem" alignItems="center">
        <FormSelect<TConnectionConfigurationInputSchema>
          name="smbConfiguration.protocol"
          label={t('device:protocol')}
          options={getSmbProtocolOptions()}
          onChange={handleSmbProtocolChange}
          disabled={disabled}
        />
        <FormInput<TConnectionConfigurationInputSchema>
          name="smbConfiguration.port"
          label={t('device:port')}
          disabled={disabled}
          type="number"
        />
      </Stack>
      <FormInput<TConnectionConfigurationInputSchema>
        name="smbConfiguration.rootDirectory"
        label={t('device:root_directory')}
        disabled={disabled}
      />
      <FormSelectSecret<TConnectionConfigurationInputSchema>
        basePath="smbConfiguration"
        label={t('device:add_smb_credentials')}
        allowCreateSecret
      />
    </FormContent>
  );
};
